var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var getUserRoutesMapper = function (data) {
    var userMenuList = {
        titles: [],
        routes: [],
    };
    data === null || data === void 0 ? void 0 : data.map(function (route) {
        var _a, _b, _c;
        userMenuList.titles = __spreadArray(__spreadArray([], __read(userMenuList === null || userMenuList === void 0 ? void 0 : userMenuList.titles), false), [route === null || route === void 0 ? void 0 : route.module_name], false);
        userMenuList.routes = __spreadArray(__spreadArray([], __read(userMenuList === null || userMenuList === void 0 ? void 0 : userMenuList.routes), false), [
            {
                routeId: route === null || route === void 0 ? void 0 : route.module_id,
                routeName: (_a = route === null || route === void 0 ? void 0 : route.module_name) !== null && _a !== void 0 ? _a : "",
                routeURL: (_b = route === null || route === void 0 ? void 0 : route.module_url) !== null && _b !== void 0 ? _b : "",
                partnerType: (_c = route === null || route === void 0 ? void 0 : route.partner_type) !== null && _c !== void 0 ? _c : "",
                isActive: route === null || route === void 0 ? void 0 : route.isactive,
            },
        ], false);
    });
    return userMenuList;
};
